export default __webpack_public_path__ + "static/media/qr-code.abb0c6fb.png";